import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Router } from '@services/route.service';
import { User } from '@services/user.service';

@Component({
  selector: 'lgb-card-tool',
  imports: [
    RouterModule
  ],
  templateUrl: './card-tool.html',
  styleUrl: './card-tool.css',
})
export class CardTool {
  readonly router=inject(Router);
  readonly userS=inject(User);
}
